/**
 * @module manifest/dimensionDateUtils
 * @description QB 维度 date 判定 — 对齐 ChartsDrop utils dimensionContainsDate / dimensionOneContainsDate
 *
 * 实际拖拽字段使用 column_type（FieldType.Date = 'date'），而非 columnType。
 */

/** 单个维度项是否为 date 类型（对齐 ChartsDrop: column_type === FieldType.Date） */
export function isDateDimensionItem(dim: unknown): boolean {
  const d = dim as Record<string, unknown>;
  const columnType = d.column_type ?? d.columnType;
  return columnType === 'date' || d.dateType !== undefined;
}

/** 维度列表中是否包含 date（ChartsDrop: dimensionContainsDate） */
export function detectDateDimensionsInList(dimensions: unknown[]): boolean {
  return dimensions.some(isDateDimensionItem);
}

/** 首个维度是否为 date（ChartsDrop: dimensionOneContainsDate） */
export function isFirstDimensionDate(dimensions: unknown[]): boolean {
  if (dimensions.length === 0) {
    return false;
  }
  return isDateDimensionItem(dimensions[0]);
}
